import React, { useMemo } from 'react';
import { profile } from '../mock';
import { Github, Linkedin, Mail } from 'lucide-react';

export default function Header({ progress = 0 }) {
  const pct = useMemo(() => Math.round(progress * 100), [progress]);
  const scene = useMemo(() => {
    if (progress < 0.25) return { id: '01', label: 'Introduction' };
    if (progress < 0.55) return { id: '02', label: 'Neural Core' };
    if (progress < 0.82) return { id: '03', label: 'Chassis & Mechanics' };
    return { id: '04', label: 'The Archive' };
  }, [progress]);

  return (
    <header className="fixed top-0 inset-x-0 z-30">
      <div className="flex items-center justify-between px-6 md:px-10 py-5">
        <div className="flex items-center gap-3">
          <div className="relative h-8 w-8 grid place-items-center rounded-md border border-cyan-400/40 bg-cyan-950/40">
            <div className="absolute inset-0 rounded-md bg-cyan-400/10" />
            <span className="mono text-[10px] text-cyan-300 tracking-widest">PB</span>
          </div>
          <div>
            <div className="display text-sm text-cyan-100 tracking-wider">ASTRA // LUMEN&nbsp;II</div>
            <div className="mono text-[10px] text-cyan-400/70 tracking-[0.3em]">PRIBIN.K.BENNY</div>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-8 mono text-[11px] tracking-[0.25em] text-cyan-200/70">
          <a href="#scene-01" className="hover:text-cyan-100 transition-colors">01 INTRO</a>
          <a href="#scene-02" className="hover:text-cyan-100 transition-colors">02 CORE</a>
          <a href="#scene-03" className="hover:text-cyan-100 transition-colors">03 CHASSIS</a>
          <a href="#scene-04" className="hover:text-cyan-100 transition-colors">04 ARCHIVE</a>
        </nav>

        <div className="flex items-center gap-2">
          <a href={profile.github} target="_blank" rel="noreferrer" className="btn-ghost rounded-md p-2"><Github size={14} /></a>
          <a href={profile.linkedin} target="_blank" rel="noreferrer" className="btn-ghost rounded-md p-2"><Linkedin size={14} /></a>
          <a href={`mailto:${profile.email}`} className="btn-ghost rounded-md p-2"><Mail size={14} /></a>
        </div>
      </div>

      {/* Progress bar */}
      <div className="relative h-[2px] w-full bg-cyan-900/30">
        <div
          className="absolute left-0 top-0 h-full"
          style={{
            width: `${pct}%`,
            background: 'linear-gradient(90deg, #22d3ee, #7dd3fc)',
            boxShadow: '0 0 12px rgba(34,211,238,0.7)',
            transition: 'width 0.15s linear',
          }}
        />
      </div>

      {/* Scene indicator */}
      <div className="pointer-events-none absolute right-6 md:right-10 top-16 hidden sm:flex items-center gap-3">
        <div className="h-2 w-2 rounded-full bg-cyan-300 pulse-dot" />
        <div className="mono text-[10px] tracking-[0.35em] text-cyan-300/80">
          SCENE {scene.id} / {scene.label.toUpperCase()}
        </div>
      </div>
    </header>
  );
}
